/* Culinvaro product card — collection, search aur related products (grid) ke liye */
(function () {
  var COLORS = {
    'black':'#2b2b2b','matte black':'#2b2b2b','white':'#f4f4f2','off white':'#f1eee6','ivory':'#f3efe4','cream':'#efe8d8',
    'beige':'#d9cbb5','light beige':'#e6dccb','sand':'#d8c7a8','cappuccino':'#a88b74','taupe':'#a39486','camel':'#b98a5e',
    'brown':'#7a5a44','dark brown':'#4e3a2c','chocolate':'#4e3a2c','walnut':'#6b4a33','oak':'#c9a27a','light oak':'#d8b98f',
    'natural':'#d8b98f','sonoma oak':'#c9a27a','wenge':'#3e2f26','dark wenge':'#3e2f26','teak':'#a0703f',
    'grey':'#9a9a98','gray':'#9a9a98','light grey':'#cfcfcd','light gray':'#cfcfcd','dark grey':'#5a5a5a','dark gray':'#5a5a5a',
    'graphite':'#4a4a4a','anthracite':'#3b3d3f','charcoal':'#3a3a3a','silver':'#c4c4c4','metallic':'#b8b8b8','chrome':'#c8c8c8',
    'green':'#6f7f6a','light green':'#a9bfa0','sage':'#9aab92','olive':'#7a7a52','dark green':'#3f5544','emerald':'#2f6b52',
    'turquoise':'#3fa6a6','teal':'#2f7f7f','blue':'#4a6a8f','light blue':'#a9c0d6','navy':'#2f3b55','dark blue':'#2f3b55',
    'grey-blue':'#7a8a99','blue-grey':'#7a8a99','blue-green':'#4f8a83','yellow':'#e3c35a','mustard':'#c9a03a','gold':'#c9a85a',
    'red':'#b5483f','burgundy':'#6e2a32','pink':'#e3b5b5','rose':'#d7a1a1','orange':'#d98a4a','terracotta':'#c46a4a',
    'purple':'#7b5c8f','lilac':'#b9a6cc','transparent':'#ececec','clear':'#ececec'
  };
  function colorFor(name) {
    var n = (name || '').toLowerCase().split(',')[0];
    if (n.indexOf(':') > -1) n = n.split(':')[1];
    n = n.replace(/\(.*?\)/g, '').replace(/\s+/g, ' ').trim();
    if (COLORS[n]) return COLORS[n];
    var words = n.split(' ');
    for (var i = 0; i < words.length; i++) {
      var two = words.slice(i, i + 2).join(' ');
      if (COLORS[two]) return COLORS[two];
    }
    for (var j = words.length - 1; j >= 0; j--) { if (COLORS[words[j]]) return COLORS[words[j]]; }
    var css = n.replace(/[\s-]/g, '');
    if (css && window.CSS && CSS.supports && CSS.supports('color', css)) return css;
    return null;
  }
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var SEL = '.cv-card--grid';

  function paintSwatches(root) {
    (root || document).querySelectorAll(SEL + ' .fh-fp-swatch[data-color-name]:not([data-cv-done])').forEach(function (sw) {
      sw.setAttribute('data-cv-done', '1');
      var c = colorFor(sw.getAttribute('data-color-name'));
      var img = sw.getAttribute('data-img');
      if (c) sw.style.backgroundColor = c;
      else if (img) sw.style.backgroundImage = 'url(' + img + ')';
    });
  }
  function setDots(card, idx) {
    var dots = card.querySelectorAll('.fh-fp-dot');
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === idx);
  }
  function goTo(slides, idx, smooth) {
    var w = slides.clientWidth;
    if (smooth && slides.scrollTo) slides.scrollTo({ left: idx * w, behavior: 'smooth' });
    else slides.scrollLeft = idx * w;
    setDots(slides.closest(SEL), idx);
  }

  // Desktop: mouse move (bina click) se images
  document.addEventListener('mousemove', function (e) {
    if (!canHover.matches || !e.target.closest) return;
    var slides = e.target.closest(SEL + ' .fh-fp-slides');
    if (!slides) return;
    var count = slides.querySelectorAll('.fh-fp-slide').length;
    if (count < 2) return;
    var r = slides.getBoundingClientRect();
    var idx = Math.min(count - 1, Math.max(0, Math.floor(((e.clientX - r.left) / r.width) * count)));
    if (slides._idx !== idx) { slides._idx = idx; goTo(slides, idx, false); }
  }, { passive: true });
  document.addEventListener('mouseout', function (e) {
    if (!canHover.matches || !e.target.closest) return;
    var slides = e.target.closest(SEL + ' .fh-fp-slides');
    if (!slides || (e.relatedTarget && slides.contains(e.relatedTarget))) return;
    if (slides._idx) { slides._idx = 0; goTo(slides, 0, false); }
  });

  // Mobile: swipe -> dots
  var t;
  document.addEventListener('scroll', function (e) {
    var slides = e.target;
    if (canHover.matches || !slides.classList || !slides.classList.contains('fh-fp-slides') || !slides.closest(SEL)) return;
    clearTimeout(t);
    t = setTimeout(function () {
      var idx = Math.round(slides.scrollLeft / slides.clientWidth);
      slides._idx = idx; setDots(slides.closest(SEL), idx);
    }, 60);
  }, { capture: true, passive: true });

  // Swatch: click / hover -> variant image
  function pick(sw) {
    var card = sw.closest(SEL); if (!card) return;
    card.querySelectorAll('.fh-fp-swatch').forEach(function (s) { s.classList.remove('is-active'); });
    sw.classList.add('is-active');
    var mid = sw.getAttribute('data-media-id'); if (!mid) return;
    var slides = card.querySelector('.fh-fp-slides');
    var all = slides.querySelectorAll('.fh-fp-slide');
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute('data-media-id') === mid) { slides._idx = i; goTo(slides, i, !canHover.matches); break; }
    }
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest(SEL + ' .fh-fp-swatch');
    if (!sw) return;
    e.preventDefault(); pick(sw);
  });
  document.addEventListener('mouseover', function (e) {
    if (!canHover.matches || !e.target.closest) return;
    var sw = e.target.closest(SEL + ' .fh-fp-swatch');
    if (sw && !sw.classList.contains('is-active')) pick(sw);
  });

  function init() {
    paintSwatches(document);
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes.length) { paintSwatches(document); break; } }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
